import { ExternalLink, Play } from "lucide-react";
import ProjectPanel from "../components/ProjectPanel";
import { Section } from "../components/Section";
import { allTrailers, featuredProjects, releasedProjects } from "../data/projects";

export default function Games() {
  return (
    <>
      <section className="page-hero compact">
        <p className="eyebrow">Work</p>
        <h1>Original games, current Steam projects, and released mobile work.</h1>
        <p>The Shed and JEFF are the current featured projects. The wider catalogue includes SZ Interactive releases and official trailers gathered from the Wix site.</p>
      </section>
      <Section eyebrow="Current projects" title="Wishlist now on Steam.">
        <div className="featured-stack">
          {featuredProjects.map((project) => <ProjectPanel key={project.slug} project={project} featured />)}
        </div>
      </Section>
      <Section eyebrow="Released games" title="Studio games across mobile, Steam, physics, puzzles, and horror.">
        <div className="project-grid">
          {releasedProjects.map((project) => <ProjectPanel key={project.slug} project={project} />)}
        </div>
      </Section>
      <Section eyebrow="Trailer archive" title="Official Wix gallery trailers.">
        <div className="trailer-grid">
          {allTrailers.map((trailer) => (
            <a className="trailer-card" href={trailer.url} target="_blank" rel="noreferrer" key={trailer.url}>
              <img src={trailer.poster} alt={`${trailer.title} poster`} loading="lazy" />
              <span className="play-chip"><Play size={16} aria-hidden="true" /> Trailer</span>
              <div>
                <h3>{trailer.title}</h3>
                {trailer.note && <p>{trailer.note}</p>}
                <span className="external-chip">Watch on YouTube <ExternalLink size={14} aria-hidden="true" /></span>
              </div>
            </a>
          ))}
        </div>
      </Section>
    </>
  );
}
